<template>
  <div class="full-height">
    <div class="row container-crud q-px-sm">
      <div class="fit">
        <q-card class="q-px-sm">
          <q-card-section class="q-py-sm">
            <div v-if="nmInterface === 'gravar'" class="crud-title">
              <translate>NEW_REGISTRATION</translate>
            </div>
            <div v-else-if="nmInterface === 'alterar'" class="crud-title">
              <translate>UPDATE</translate>
            </div>
          </q-card-section>
          <q-card-section class="q-px-lg">
            <span v-if="elements ? elements.length == 1 : false">
              <q-btn
                color="grey-3"
                text-color="primary"
                icon="perm_contact_calendar"
                class="view-button-carrier"
                flat
                :label="$gettext('DATA_COMPLETE')"
                @click="openModel"
                :disabled="!this.elements[0].dadosForm.person"
              >
                <q-tooltip>{{ $gettext('VIEW_COMPLETE_DATA') }}</q-tooltip>
              </q-btn>
              <jt-dynamic-form
                v-if="elements[0]"
                ref="dynamicForm"
                :inputs="inputs"
                :relacionamentos="elements[0].relacionamentos"
                :model="elements[0].dadosForm"
                :interface="elements[0].nmInterface"
                form-class="form dynamic"
                @search-found="selections"
                @composition-button-click="onCompositionButtonClick"
              />
            </span>
          </q-card-section>
          <q-dialog v-if="flModal" v-model="flModal">
            <q-layout
              view="Lhh lpR fff"
              container
              class="bg-white modal-medium"
            >
              <q-header class="bg-primary">
                <q-toolbar>
                  <q-toolbar-title>{{
                    $gettext("VIEW_COMPLETE_DATA")
                  }}</q-toolbar-title>
                  <q-btn
                    v-close-popup
                    flat
                    round
                    dense
                    size="1.5em"
                    icon="cancel"
                  />
                </q-toolbar>
              </q-header>
              <q-page-container class="card-container-modal">
                <page
                  :name="pageDialog.name"
                  :params="pageDialog.params"
                  :forms="pageDialog.forms"
                />
              </q-page-container>
            </q-layout>
          </q-dialog>
        </q-card>
      </div>
    </div>
    <div
      v-if="forms && forms.length > 0 && forms[0].buttons && forms[0].buttons.length > 0"
      class="row full-width q-col-gutter-lg justify-center q-pt-lg"
    >
      <div class="col-lg-2 col-md-3">
        <q-btn class="full-width" color="grey-7" @click="limparForm">
          <translate>CLEAN</translate>
        </q-btn>
      </div>
      <div
        v-for="(button, i) in forms[0].buttons"
        :key="i"
        class="col-lg-2 col-md-3"
      >
        <q-btn
          class="full-width"
          color="info"
          @click="actionButton(button)"
        >
          <q-icon
            v-if="button.icon"
            :name="button.icon"
            size="18px"
            class="position-icon-filter"
          />
          {{ button.label }}
        </q-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm } from 'jtech-webcomps'
import { repository } from 'jtech'
const { page } = JtCrud

@Component({
  mixins: [page],
  name: 'Carrier',
  components: { JtDynamicForm, page },
  props: {
    name: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object
  }
})
class CarrierPage extends Vue {
  nmInterface = null;
  flModal = false;
  pageDialog = null;

  mounted () {
    if (this.elements) { this.nmInterface = this.elements[0].nmInterface.split('.')[1] }
  }

  get inputs () {
    this.elements[0].inputs.find(
      (input) => input.model == 'person'
    ).type = 'person_search'
    return this.elements[0].inputs
  }

  async openModel () {
    const params = { id: this.elements[0].dadosForm.person }
    const forms = await repository.resolve('carrier.detalharCustom', params)
    this.formatContactsPerson(forms[0].dadosForm.contactPersons)
    this.pageDialog = {
      name: 'label',
      params: params,
      forms: forms
    }
    this.flModal = true
  }

  async selections (data) {
    const { person, available } = this.elements[0].dadosForm

    if (data.person.idField) {
      const param = { id: data.person.idField }
      const { registros } = await repository.resolveDatatableModel(
        'person.pesquisarSelecao',
        param
      )
      delete registros[0].id
      delete registros[0].idAcaoGrid

      this.elements[0].dadosForm = {
        ...this.elements[0].dadosForm,
        ...registros[0]
      }
    } else {
      this.elements[0].dadosForm = {
        person,
        available
      }
    }
  }

  formatContactsPerson (contactsPerson) {
    contactsPerson.forEach((row, index) => {
      if (row.contactPersonEmails?.length) {
        row.contactPersonEmailsMain = row.contactPersonEmails[0].email
        row.contactPersonEmailsSub = row.contactPersonEmails
          .slice(1, row.contactPersonEmails.length)
          .map(e => e.email)
          .join(', ')
      }

      if (row.contactPersonPhones?.length) {
        row.contactPersonPhonesMain = row.contactPersonPhones[0].phone
        row.contactPersonPhonesSub = row.contactPersonPhones
          .slice(1, row.contactPersonPhones.length)
          .map(e => e.phone)
          .join(', ')
      }
    })
  }

  onCompositionButtonClick (eventObject) {
    const { button: clickedButton } = eventObject
    switch (clickedButton.name) {
      case 'icDetalharDocument':
        this.$emit(
          'action-button',
          eventObject.button,
          eventObject.params,
          this
        )
        break
      case 'icDetalharComposicaoGenerator':
        this.$emit(
          'action-button',
          eventObject.button,
          eventObject.params,
          this
        )
        break
      case 'icAlterarComposicaoGenerator':
        this.$emit(
          'action-button',
          eventObject.button,
          eventObject.params,
          this
        )
        break
    }
  }
}
export default CarrierPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';

.view-button-carrier{
  position: absolute;
  top: -46px;
  right: 14px;
  border-radius: 5px;
}

</style>
